import * as t from 'io-ts';

import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

export const RImpersonationRequestDirty = t.readonly(
  t.type({
    requesterName: t.union([t.undefined, t.string]),
  }),
);

/*
 * Types.
 */

export interface ImpersonationRequestModel extends t.TypeOf<typeof RImpersonationRequestDirty> {}
const RImpersonationRequest = t.clean<ImpersonationRequestModel>(RImpersonationRequestDirty as any);

/*
 * IO methods.
 */

function parseImpersonationRequest(src: any) {
  return {requesterName: src.requester.name};
}

/*
 * API type.
 */

export const ApiImpersonationRequest = makeApiType(
  'impersonationRequest',
  RImpersonationRequest,
  parseImpersonationRequest,
);
